export enum SituacaoMigracaoEnum {
  NATIVO = 'NATIVO',
  EMIGRANTE = 'EMIGRANTE',
  IMIGRANTE = 'IMIGRANTE'
}
